import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import StudyFlow from 'components/Flows/StudyFlows/StudyFlows';
import StudyAnalysisDrawer from 'components/Analyses/StudyAnalyses/Drawer/Drawer';

const StudyFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <StudyAnalysisDrawer />
      <StudyFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <StudyFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);